import { render, staticRenderFns } from "./UpgradePackagesDialog.vue?vue&type=template&id=5ad2b8a2&scoped=true"
import script from "./UpgradePackagesDialog.vue?vue&type=script&lang=js"
export * from "./UpgradePackagesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad2b8a2",
  null
  
)

export default component.exports